<template>
    <div id="login-kindergarten" class="general-container">
        <div class="bg"></div>
        <div class="general-container--bg"></div>

        <div class="main-container">
            <div class="header">
                <i class="logo" :style="{backgroundImage: `url(${schoolLogo})`}"></i>
                <span class="header--text">{{schoolName}}在线{{schoolType == 1 ? '入园' : '入校'}}意向登记</span>
            </div>
            <div class="login-container">
                <div class="login-container__inner">
                    <div class="login-mobileing-container">
                        <el-form autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm"
                                 label-position="left" label-width="0px" class="card-box login-form">
                            <el-form-item prop="userName" class="white-back">
                            <span class="svg-container">
                                <i class="icon iconfont icon-identification"></i>
                            </span>
                                <el-input maxlength="5" name="userName" type="text" v-model="loginForm.userName" autoComplete="on"
                                          :placeholder="`${schoolType == 1 ? '幼儿' : '学生'}姓名`"></el-input>
                            </el-form-item>
                            <el-form-item class="white-back">
                                <el-select style="width: 419px" v-model="cardType" placeholder="请选择">
                                    <el-option :key="1" label="身份证" :value="1"></el-option>
                                    <el-option :key="2" label="护照" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-show="cardType === 1" prop="cardId" class="white-back">
                            <span class="svg-container">
                                <i class="icon iconfont icon-identification"></i>
                            </span>
                                <el-input name="cardId" type="text" v-model="loginForm.cardId" autoComplete="on"
                                          :placeholder="`${schoolType == 1 ? '幼儿' : '学生'}身份证号`"></el-input>
                            </el-form-item>
                            <el-form-item v-show="cardType === 2" prop="passport" class="white-back">
                            <span class="svg-container">
                                <i class="icon iconfont icon-identification"></i>
                            </span>
                                <el-input name="passport" type="text" v-model.trim="loginForm.passport" autoComplete="on"
                                          :placeholder="`${schoolType == 1 ? '幼儿' : '学生'}护照号`" :maxlength="20"></el-input>
                            </el-form-item>
                            <el-form-item v-show="cardType === 2" class="white-back">
                                <el-select style="width: 419px" v-model="loginForm.gender" placeholder="请选择">
                                    <el-option :key="1" label="男" :value="1"></el-option>
                                    <el-option :key="2" label="女" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-show="cardType === 2" class="white-back" prop="birthday">
                                <el-date-picker
                                    style="width: 419px"
                                    v-model="loginForm.birthday"
                                    type="date"
                                    :placeholder="`请选择${schoolType == 1 ? '幼儿' : '学生'}生日`"
                                >
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item prop="mobile" class="white-back">
                            <span class="svg-container">
                                <i class="icon iconfont icon-identification"></i>
                            </span>
                                <el-input name="mobile" type="text" v-model="loginForm.mobile" autoComplete="on"
                                          placeholder="家长手机号"></el-input>
                            </el-form-item>

                            <el-form-item prop="code" class="white-back">
                            <span class="svg-container">
                                <i class="icon iconfont icon-password"></i>
                            </span>
                                <div class="input-item">
                                    <el-input name="code" type="text" v-model="loginForm.code" autoComplete="on"
                                              placeholder="验证码" @keyup.enter.native="handleLogin"></el-input>
                                </div>
                                <div class="input-item input-item--code">
                                    <el-button style="box-sizing: border-box;height: 40px;line-height: 14px;" type="primary" @click="sendCode" :class="['code-button', canSendCode ? 'code-button--active' : 'code-button--inactive']">
                                        {{canSendCode ? '获取验证码' : `${sendCodeSecond}s后可重发`}}
                                    </el-button>
                                </div>

                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" style="width:100%;" :loading="loading"
                                           @click.native.prevent="handleLogin">
                                    登录
                                </el-button>
                            </el-form-item>
                            <div class="hint">
                                注：该表为预登记信息收集，不做最终报名结果依据
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import idCard from 'idcard';
    import baseMixin from '@/mixins/baseMixin.js'
    import {
        checkCode,
        getTonken,
        getCode,
        checkCarId,
        queryById,
        checkBirthDate
    } from '@/api/outer';
    import moment from 'moment';

    export default {
        name: "Login",
        mixins: [baseMixin],
        data() {
            const cardIdValidator = (rule, value, callback) => {
                if(this.cardType === 1 && this.loginForm.cardId === '') {
                    callback(new Error('身份证号不能为空！'));
                } else {
                    callback();
                }
            };
            const passportValidator = (rule, value, callback) => {
                if(this.cardType === 2 && this.loginForm.passport === '') {
                    callback(new Error('护照号不能为空！'));
                } else {
                    callback();
                }
            };
            const birthdayValidator = (rule, value, callback) => {
                const beginYear = sessionStorage.getItem('signup_beginyear');
                const endYear = sessionStorage.getItem('signup_endyear');
                if(this.cardType === 2) {
                    if(this.loginForm.birthday === '') {
                        callback(new Error('生日不能为空！'));
                    }  else {
                        callback();
                    }
                } else {
                    callback();
                }
            };

            return {
                id: this.$route.query.id,
                schoolId: this.$route.query.schoolId,
                voteId: this.$route.query.voteId,
                canSendCode: true,
                sendCodeSecond: 60,
                loading: false,//登录按钮加载
                loginRules: {
                    userName: [
                        {required: true, message: '姓名不能为空！', trigger: 'blur'}
                    ],
                    mobile: [
                        {required: true, message: '手机号码不能为空！', trigger: 'blur'}
                    ],
                    code: [
                        {required: true, message: '验证码不能为空！', trigger: 'blur'}
                    ],
                    cardId: [
                        {required: true, trigger: 'blur', validator: cardIdValidator}
                    ],
                    passport: [{
                        required: true, trigger: 'blur', validator: passportValidator
                    }],
                    birthday: [{
                        required: true, trigger: 'blur', validator: birthdayValidator
                    }]
                },
                loginForm: {
                    userName: '',
                    mobile: '',
                    code: '',
                    cardId: '',
                    passport: '',
                    gender: 1,
                    birthday: ''
                },
                schoolLogo: '',
                schoolName: '',
                cardType: 1,
                schoolType: 1
            }
        },
        created() {
            queryById({
                id: this.schoolId
            })
                .then(res => res.data)
                .then(data => {
                    this.schoolName = data.data.name;
                    this.schoolLogo = data.data.roundLogoUrl;
                    this.schoolType = data.data.type;
                })
        },
        mounted() {

        },
        methods: {
            sendCode() {
                if(this.canSendCode) {
                    const phoneReg = /^[1][345789][0-9]{9}$/;
                    if(this.loginForm.mobile === '') {
                        this.$message.error('请输入手机号！');
                    } else if(!phoneReg.exec(this.loginForm.mobile)) {
                        this.$message.error('手机号格式不正确！');
                    } else {
                        getCode({
                            mobile: this.loginForm.mobile,
                            noticeId: this.id,
                            schoolId: this.schoolId
                        })
                            .then(res => res.data)
                            .then(data => {
                                if(data.result) {
                                    this.canSendCode = false;
                                    this.sendCodeIntervalId = setInterval(() => {
                                        this.sendCodeSecond --;
                                        if(this.sendCodeSecond === 0) {
                                            this.sendCodeSecond = 60;
                                            this.canSendCode = true;
                                            clearInterval(this.sendCodeIntervalId);
                                        }
                                    }, 1000);
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                    }
                }
            },
            handleLogin() {
                this.$refs.loginForm.validate((valid) => {
                    if (valid) {
                        checkCode({
                            code: this.loginForm.code,
                            mobile: this.loginForm.mobile,
                            noticeId: this.id,
                        })
                            .then(res => res.data)
                            .then(data => {
                                if(data.result) {
                                    if(this.cardType === 1) {
                                        if(idCard.verify(this.loginForm.cardId.toUpperCase())) {
                                            checkCarId({
                                                cardId: this.loginForm.cardId,
                                                noticeId: this.id,
                                                schoolId: this.schoolId,
                                            })
                                                .then(res => res.data)
                                                .then(data => {
                                                    if(data.result) {
                                                        getTonken({
                                                            cardId: this.loginForm.cardId,
                                                            mobile: this.loginForm.mobile,
                                                            noticeId: this.id,
                                                            schoolId: this.schoolId,
                                                            voteId: this.voteId,
                                                            userName: this.loginForm.userName,
                                                            cardType: this.cardType
                                                        })
                                                            .then(res => res.data)
                                                            .then(data => {
                                                                if(data.result) {
                                                                    sessionStorage.setItem('fromOuterLogin', 1);
                                                                    sessionStorage.setItem('outerToken', data.data);
                                                                    this.$router.push({
                                                                        path: 'outerQuestionnaire',
                                                                        query: {
                                                                            userName: this.loginForm.userName,
                                                                            mobile: this.loginForm.mobile,
                                                                            cardId: this.loginForm.cardId,
                                                                            schoolType: this.schoolType,
                                                                            schoolId: this.schoolId,
                                                                        }
                                                                    });
                                                                } else {
                                                                    this.$message.error(data.msg);
                                                                }
                                                            })
                                                    } else {
                                                        this.$message.error(data.msg);
                                                    }
                                                })
                                        } else {
                                            this.$message.error('身份证不正确');
                                        }
                                    } else {
                                        checkBirthDate({
                                            birthDate: moment(this.loginForm.birthday).format('YYYY-MM-DD'),
                                            noticeId: this.id,
                                            schoolId: this.schoolId
                                        })
                                            .then(res => res.data)
                                            .then(data => {
                                                if(data.result) {
                                                    getTonken({
                                                        cardId: this.loginForm.passport,
                                                        mobile: this.loginForm.mobile,
                                                        noticeId: this.id,
                                                        schoolId: this.schoolId,
                                                        voteId: this.voteId,
                                                        userName: this.loginForm.userName,
                                                        birthDate: moment(this.loginForm.birthday).format('YYYY-MM-DD'),
                                                        cardType: this.cardType,
                                                        gender: this.loginForm.gender
                                                    })
                                                        .then(res => res.data)
                                                        .then(data => {
                                                            if(data.result) {
                                                                sessionStorage.setItem('fromOuterLogin', 1);
                                                                sessionStorage.setItem('outerToken', data.data);
                                                                this.$router.push({
                                                                    path: 'outerQuestionnaire',
                                                                    query: {
                                                                        schoolId: this.schoolId,
                                                                        userName: this.loginForm.userName,
                                                                        mobile: this.loginForm.mobile,
                                                                        cardId: this.loginForm.passport,
                                                                        gender: this.loginForm.gender,
                                                                        birthday: moment(this.loginForm.birthday).format('YYYY-MM-DD')
                                                                    }
                                                                });
                                                            } else {
                                                                this.$message.error(data.msg);
                                                            }
                                                        })
                                                } else {
                                                    this.$message.error(data.msg);
                                                }
                                            })

                                    }

                                } else {
                                    this.$message.error('验证码验证失败');
                                }
                            })
                    }
                });
            }

        }
    }
</script>

<style scoped lang="scss">
    @import "../../../styles/mixin";
    @include reset-global;

    @media screen and (max-height: 800px) {
        .header {
            top: -67px !important;
            font-size: 30px !important;
            .logo {
                width: 60px !important;
                height: 60px !important;
            }
        }
    }

    .bg {
        position: fixed;
        top: 0;
        bottom: 0;
        left:0;
        right: 0;
        background: no-repeat center center / 100% 100% url(https://cdnfile-10043692.file.myqcloud.com/schoolSignup/bj2.jpg);
    }
    .general-container {
        width: 100%;
        height: 100%;
        .general-container--bg {
            @include fullByPostion;
        }
    }
    .main-container {
        z-index: 2000;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -42%);
    }
    .header {
        text-align: center;
        font-size: 40px;
        padding-bottom: 34px;
        z-index: 2000;
        position: absolute;
        margin: 0 auto;
        top: -124px;
        width: 1000px;
        left: 50%;
        transform: translateX(-50%);
        & > * {
            @include middleIB;
        }
        .header--logo {
            @include wh(98px, 108px);
            @include cover-bg;
            margin-right: 24px;
        }
    }
    .login-container {
        position:relative;
        color: #304E72;
        border: 1px solid #333;
        box-shadow: #666 4px 4px 10px;
        background-color: #fff;
        border-radius: 10px;
        z-index: 2001;
        padding: 10px;
        .login-container__inner {
            @include wh(487px, 543px);
            box-sizing: border-box;
            padding: 20px 34px;
            border-radius: 10px;
        }
    }
    .login-tab {
        @include middleIB;
        font-size: 22px;
        text-align: center;
        width: 50%;
        .login-tab--inner {
            cursor: pointer;
            display: inline-block;
            border-bottom: 2px solid transparent;
            padding-bottom: 20px;
        }
        &--active {
            .login-tab--inner {
                border-color: #304E72;
            }
        }
    }
    .login-code-container {
        position: relative;
        .login-code-cornor {
            position: absolute;
            @include wh(30px, 30px);
        }
        .login-code-cornor--1 {
            border-top: 2px solid #304E72;
            border-left: 2px solid #304E72;
            left: 50px;
        }
        .login-code-cornor--2 {
            border-top: 2px solid #304E72;
            border-right: 2px solid #304E72;
            left: 344px;
        }
        .login-code-cornor--3{
            border-bottom: 2px solid #304E72;
            border-left: 2px solid #304E72;
            left: 50px;
            top: 294px;
        }
        .login-code-cornor--4 {
            border-bottom: 2px solid #304E72;
            border-right: 2px solid #304E72;
            left: 344px;
            top: 294px;
        }
    }
    .login-mobileing-container {
        margin-top: 22px;
    }

    .school-item {
        width: 140px;
        height: 140px;
        float: left;
        text-align: center;
        cursor: pointer;
        margin-left: 10px;
        margin-bottom: 10px;
        border-radius: 4px;
        border: 2px solid #fff;
        &.school-chosed {
            border: 2px solid #20a0ff;
        }
    }
    .school-logo {
        width: 100px;
        height: 100px;
        margin: 4px auto;
        background-position: center center;
        background-size: cover;
    }
    .logo {
        @include middleIB;
        @include wh(90px, 90px);
        @include cover-bg;
        margin-right: 10px;
    }


    #login-code {
        overflow: hidden;
        margin-left: 64px;
        margin-top: 40px;
    }
    .input-item {
        width: 70%;
        float: left;
    }
    .input-item--code {
        float: right;
        width: auto;
    }
    .hint {
        width: 80%;
        color: red;
        text-align: center;
        margin: 10px auto 0 auto;
        font-size: 16px;
    }
</style>
<style lang="scss">
    #login-kindergarten {

        .svg-container {
            position: absolute;
            z-index: 2000;
            right: 14px;
            height: 60px;
            line-height: 58px;
            opacity: 0.7;
            i {
                font-size: 30px;
            }
        }
        .login-mobileing-container {
            .el-input__inner {
                height: 40px;
                line-height: 40px;
            }

            .el-form-item {
                margin-bottom: 20px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/kindergarten/outer/OuterLogin.vue